import React from 'react';
import Container from './Components/Container';

const App: React.FC = () => {
  return <Container />;
};

export default App;
